/***
 * Created on 2025/10/30
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import useToggle from "../../hook/ToggleHook";
import {normalizeSpaceSize} from "../../service/utils";

function CloudSpaceRegionStatsToolbarComponent({usage_data, state, dispatch}) {
    const { t } = useTranslation();
    const [open, node] = useToggle();

    const onSelectRegion = (region_item) => {
        dispatch({
            type: 'set_region',
            payload: region_item,
        });
    }

    return (
        <div className="toolbar toolbar--cloud-space">
            <div className="col-wrapper">
                <div className="col-left">
                    <div className="select-group mr-8">
                        <div className="comp-select comp-select--small auto-width drop-adjustable">
                            <div className="select-toggle" ref={node}>
                                <div className="select-label-wrapper">
                                    <span className="select-pre-label">{t('@Region@')}</span>
                                    <span className="select-label">
                                        <span className="font-medium">{t(`@${state?.current_region?.region}@`)}</span>
                                    </span>
                                </div>
                            </div>
                            <div className={`comp-dropdown ${open}`}>
                                <ul className="comp-dropdown-menu">
                                    {
                                        usage_data?.data?.sort((a,b)=> t(`@${a.region}@`).localeCompare(t(`@${b.region}@`)))?.map((region_item, index) => (
                                            <li className="section" key={index} onClick={e => onSelectRegion(region_item)}>
                                                <div className="section-items selection">{t(`@${region_item.region}@`)}</div>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="amount-info fs14 !ml-10">{t('@Total Space:@')}<span className="hi-light !pl-8">
                        {state?.current_region?.space_cnt || 0}
                    </span></div>
                    <div className="func-divide !ml-16 !mr-16"></div>
                    <div className="amount-info fs14 !ml-10">{t('@Used Space:@')}<span className="hi-light !pl-8">
                        {normalizeSpaceSize(state?.current_region?.quota?.used)}
                    </span></div>
                    <div className="func-divide !ml-16 !mr-16"></div>
                    <div className="amount-info fs14 !ml-10">{t('@Free Space:@')}<span className="hi-light !pl-8">
                        {normalizeSpaceSize(state?.current_region?.quota?.total)}
                    </span></div>
                </div>
            </div>
        </div>
    );
}

export default CloudSpaceRegionStatsToolbarComponent;